// extracted by mini-css-extract-plugin
export var addButton = "_ng-0";
export var border = "_ng-8";
export var check = "_ng-h";
export var danger = "_ng-6";
export var dropdownContainer = "_ng-1";
export var editModalBody = "_ng-j";
export var footerContainer = "_ng-i";
export var fullWidth = "_ng-a";
export var hide = "_ng-9";
export var icon = "_ng-3";
export var input = "_ng-7";
export var inputFlex = "_ng-b";
export var inputWrapper = "_ng-c";
export var manualFocus = "_ng-5";
export var optionButton = "_ng-4";
export var pillWrapper = "_ng-e";
export var pointer = "_ng-2";
export var showOverflow = "_ng-f";
export var tagsFlex = "_ng-d";
export var xButton = "_ng-g";